import { render, staticRenderFns } from "./StopReportDetails.vue?vue&type=template&id=711b2db0&scoped=true&"
import script from "./StopReportDetails.vue?vue&type=script&lang=js&"
export * from "./StopReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./StopReportDetails.vue?vue&type=style&index=0&id=711b2db0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711b2db0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('711b2db0')) {
      api.createRecord('711b2db0', component.options)
    } else {
      api.reload('711b2db0', component.options)
    }
    module.hot.accept("./StopReportDetails.vue?vue&type=template&id=711b2db0&scoped=true&", function () {
      api.rerender('711b2db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/StopReportDetails.vue"
export default component.exports